
import { GROUPS_PERMISSIONS, USERS_PERMISSIONS } from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import {changeParamsToQuery} from './commonFn';

export class UsersGroupPermissionsService {

  static instance;


  static getInstance() {
    if (!UsersGroupPermissionsService.instance) {
      UsersGroupPermissionsService.instance = new UsersGroupPermissionsService();
    }
    return UsersGroupPermissionsService.instance;
  }

  updateGroupPermissions = async (params) => {
    let newsResponse = await Api.post(`${GROUPS_PERMISSIONS.URL}`, params);
    return newsResponse;
  }

  fetchGroupPermissions = async (params) => {
    let newsResponse = await Api.get(`${GROUPS_PERMISSIONS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }


  updateUserPermissions = async (params) => {
    let newsResponse = await Api.post(`${USERS_PERMISSIONS.URL}`, params);
    return newsResponse;
  }

  fetchUserPermissions = async (params) => {
    let newsResponse = await Api.get(`${USERS_PERMISSIONS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }




}

